export default "/images/framer.svg?5fd155e5373038377f668b3e3a1ae890";